import React from "react";
import {
  Box,
  TextField,
  Typography,
  Link,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import styles from "./signuplogin.module.css";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { FaUserTie } from "react-icons/fa6";
import { GoLightBulb } from "react-icons/go";
import Fade from "react-reveal/Fade";
import {
  faEye,
  faEyeSlash,
  faCheck,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { BsFileCodeFill } from "react-icons/bs";
import { IoLockClosedSharp } from "react-icons/io5";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import WordAnimation from "./WordAnimation";
import logo from "../../assets/images/Latest Logo.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import "./loginsignup.css";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { login, resetPassword, resetStatus } from "../../redux/auth/authSlice";
import { ToastContainer } from "react-toastify";
import {
  getProfile,
  resetProfileStatus,
} from "../../redux/profile/profileSlice";
import { IoIosMailOpen } from "react-icons/io";
import { addProfileData } from "../../redux/static/staticSlice";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const authStatus = useSelector((state) => state.auth.status);
  const authRes = useSelector((state) => state.auth.user);
  const profile = useSelector((state) => state.profile.data);
  const profileStatus = useSelector((state) => state.profile.status);

  const validate = () => {
    const errors = {};
    if (!username) errors.username = "User ID is required";
    if (!password) errors.password = "Password is required";
    if (!code) errors.code = "Code is required";
    if (captcha !== code) errors.code = "Capctha not match";
    return errors;
  };
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
  });
  // const [menuOpen, setMenuOpen] = useState(false);

  // const toggleMenu = () => {
  //   setMenuOpen(!menuOpen);
  // };
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const generateCaptcha = () => {
    const chars = "0123456789";
    let captcha = "";
    for (let i = 0; i < 2; i++) {
      captcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return captcha;
  };

  useEffect(() => {
    setCaptcha(generateCaptcha());
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length === 0) {
      dispatch(login({ username, password }));
    } else {
      setErrors(errors);
    }
  };

  const handleOnClickSubmitForgotPassword = () => {
    if (
      Object.keys(formik.errors).length === 0 &&
      Object.keys(formik.touched).length !== 0
    ) {
      dispatch(resetPassword(formik.values));
    }
  };

  useEffect(() => {
    if (authRes && authStatus === "signin_succeeded") {
      dispatch(getProfile());
      navigate("/profile");
    } else if (authStatus === "reset_password_succeeded") {
      handleClose();
    }
  }, [authRes, authStatus]);

  useEffect(() => {
    dispatch(resetStatus());
    dispatch(resetProfileStatus());
  }, []);

  // useEffect(() => {
  //   if (profileStatus === "get_profile_succeeded") {
  //     const areAllFieldsEmptyOrMissing =
  //       // !profile?.profile?.company_name &&
  //       !profile?.profile?.linkedin_profile_url &&
  //       !profile?.profile?.designation &&
  //       !profile?.profile?.gender &&
  //       (profile?.profile?.experience == null ||
  //         profile?.profile?.experience === "");

  //     if (
  //       profile &&
  //       authRes &&
  //       authStatus === "signin_succeeded" &&
  //       areAllFieldsEmptyOrMissing
  //     ) {
  //       navigate("/profile");
  //       localStorage.setItem(
  //         "pofileViewData",
  //         JSON.stringify({ userDetails: profile?.profile, type: "login" })
  //       );
  //     } else if (profile && authRes && authStatus === "signin_succeeded") {
  //       navigate("/profile");
  //     }
  //   }
  // }, [authRes, authStatus, profile, profileStatus]);

  useEffect(() => {
    if (profile) {
      dispatch(addProfileData(profile?.profile?.role));
    }
  }, [profile]);

  return (
    <Box>
      {/* {authStatus === "loading" && <Spinner />} */}
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>

        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact us
            </b>
          </a>
        </span>

        {/* Hamburger menu for mobile view */}
        {/* <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span> */}

        {/* Mobile Menu */}
        {/* {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px  ",
                  fontWeight: "500",
                }}
              >
                Home
              </b>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </b>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                About us
              </b>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Contact us
              </b>
            </a>
          </Box>
        )} */}
      </Box>
      <Box className={styles.signup_details}>
        <Grid container>
          {!isMobile && (
            <Grid
              item
              xs={12}
              sm={12}
              md={7}
              lg={7}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0 0 0 100px",
                marginBottom: "35px",
              }}
            >
              <span>
                <br />
                <Box className={styles.text_details}>
                  {/* Typography Block for Desktop */}
                  <Typography
                    sx={{ marginBottom: "10px", fontSize: "25px !important" }}
                  >
                    <b>Hello IT Professional!</b>
                  </Typography>
                  <br />
                  <Typography
                    sx={{ marginBottom: "20px", fontSize: "17px !important" }}
                  >
                    We are happy to announce that
                    <br />
                    Daily 1000+ IT professionals are getting double benefits for
                    their
                    <br />
                    same effort with our AI-integrated job board and ATS.
                  </Typography>
                  <br />
                  <Typography
                    sx={{ fontSize: "17px !important", lineHeight: "2.5" }}
                  >
                    <IoCheckmarkCircleOutline /> Start exploring the beautiful
                    platform, no payment required.
                    <br />
                    <IoCheckmarkCircleOutline /> An advanced feature-loaded job
                    board and ATS.
                    <br />
                    <IoCheckmarkCircleOutline /> Easy to use and fast
                    forwarding.
                  </Typography>
                </Box>
              </span>
            </Grid>
          )}

          {isMobile && (
            <Grid
              item
              xs={12}
              sm={12}
              md={7}
              lg={7}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "65px 0 0 30px",
              }}
            >
              <span>
                <br />
                <Box sx={{ color: "#fff" }}>
                  <Typography
                    sx={{ marginBottom: "10px", fontSize: "20px !important" }}
                  >
                    <b>Hello IT Professional!</b>
                  </Typography>
                  <br />
                  <Typography
                    sx={{ marginBottom: "20px", fontSize: "16px !important" }}
                  >
                    We are happy to announce that
                    <br />
                    Daily 1000+ IT professionals are getting double benefits for
                    their same effort with our AI-integrated job board and ATS.
                  </Typography>
                </Box>
              </span>
            </Grid>
          )}
          <Fade bottom delay={100}>
            <Grid item xs={12} sm={12} md={5} lg={5}>
              <Box className={styles.box_contain}>
                <Box className={styles.text_contain}>
                  <Typography
                    sx={{
                      fontSize: "20px !important",
                      marginBottom: "10px",
                      padding: "0 15px 10px 25px",
                    }}
                  >
                    <b>Login!</b>
                  </Typography>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      sx={{ padding: "0 10px" }}
                    >
                      <div
                        className="signup_form_group"
                        style={{ padding: "0 10px" }}
                      >
                        <span className="field_icon">
                          <FaUserTie />
                          <TextField
                            type="text"
                            name="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="User ID"
                            sx={{
                              width: "100%",
                              backgroundColor: "#fff",
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  border: "none !important",
                                },
                              },
                            }}
                          />
                        </span>

                        {errors.username && (
                          <p className="login_error">{errors.username}</p>
                        )}
                      </div>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      sx={{ padding: "0 10px" }}
                    >
                      <div
                        className="signup_form_group"
                        style={{ padding: "0 10px" }}
                      >
                        <span className="field_icon">
                          <IoLockClosedSharp />
                          <TextField
                            type={showPassword ? "text" : "password"}
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Password"
                            sx={{
                              width: "100%",
                              backgroundColor: "#fff",
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  border: "none !important",
                                },
                              },
                            }}
                            // inputProps={{
                            //   maxLength: 10,
                            // }}
                          />
                        </span>
                        {/* <FontAwesomeIcon
                          icon={
                            password.length > 0 &&
                            (showPassword ? faEyeSlash : faEye)
                          }
                          onClick={toggleShowPassword}
                          className="password-icon"
                        /> */}
                        {password.length > 0 && (
                          <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye}
                            onClick={toggleShowPassword}
                            className="password-icon"
                          />
                        )}

                        {errors.password && (
                          <p className="login_error">{errors.password}</p>
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      sx={{ padding: "0 10px" }}
                    >
                      <div
                        className="signup_form_group"
                        style={{ padding: "0 10px" }}
                      >
                        <span className="field_icon">
                          <BsFileCodeFill />
                          <TextField
                            id="code"
                            name="code"
                            placeholder="Enter Code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            sx={{
                              width: "100%",
                              backgroundColor: "#fff",
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  border: "none !important",
                                },
                              },
                            }}
                            inputProps={{
                              maxLength: 6,
                            }}
                          />
                        </span>
                      </div>
                    </Grid>
                  </Grid>
                  {code.length === 2 && (
                    <FontAwesomeIcon
                      icon={captcha === code ? faCheck : faXmark}
                      onClick={toggleShowPassword}
                      className="check-icon"
                      style={{ color: captcha === code ? "green" : "red" }}
                    />
                  )}

                  {/* <FontAwesomeIcon
                    icon={
                      code.length === 2 &&
                      (captcha === code ? faCheck : faXmark)
                    }
                    onClick={toggleShowPassword}
                    className="check-icon"
                    style={
                      code.length === 2 &&
                      (captcha === code ? { color: "green" } : { color: "red" })
                    }
                  /> */}
                  {errors.code && <p className="login_error">{errors.code}</p>}

                  <div className="captcha-container">
                    <span className="captcha">{captcha}</span>
                    <button
                      type="button"
                      onClick={() => setCaptcha(generateCaptcha())}
                      className="refresh-captcha"
                    >
                      Refresh
                    </button>
                  </div>
                  <Box className={styles.login_btn}>
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      style={
                        authStatus === "loading" ? { padding: "7px 40px" } : {}
                      }
                    >
                      {authStatus === "loading" ? (
                        <CircularProgress size={12} sx={{ color: "#fff" }} />
                      ) : (
                        "Login"
                      )}
                    </button>
                  </Box>
                </Box>
                <Typography variant="body2" sx={{ margin: "0 25px" }}>
                  <p
                    className="forgot_password"
                    style={{ cursor: "pointer" }}
                    onClick={handleClickOpen}
                  >
                    Forget user ID and password?
                  </p>
                </Typography>
                <Box className={styles.account_contain}>
                  <p
                    className="forgot_password"
                    style={{ marginBottom: "10px" }}
                  >
                    Don’t have any account -
                    <b
                      style={
                        authStatus === "loading"
                          ? {
                              color: "#3856a6",
                              textDecoration: "none",
                              cursor: "pointer",
                              pointerEvents: "none",
                            }
                          : {
                              color: "#3856a6",
                              textDecoration: "none",
                              cursor: "pointer",
                            }
                      }
                      onClick={() => navigate("/it-recruiter-signup")}
                    >
                      Sign Up!
                    </b>
                  </p>
                  <Typography
                    sx={{
                      position: { md: "relative", xs: "relative" },
                      bottom: { md: "75px", xs: "0" },
                    }}
                  >
                    Switch to Bench Sales Recruiter{" "}
                    <Link
                      onClick={() => navigate("/benchsales-signup")}
                      href="#"
                      style={
                        authStatus === "loading"
                          ? { pointerEvents: "none" }
                          : {}
                      }
                    >
                      Sign Up{" "}
                    </Link>
                    <FaArrowRightLong
                      style={{ color: "#3856a6", fontSize: "20px" }}
                    />
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Fade>
        </Grid>
      </Box>
      <Box
        sx={{
          padding: "40px 0 0 100px",
          display: { xs: "none", sm: "block" },
        }}
      >
        <WordAnimation />
      </Box>

      <Typography
        sx={{
          fontSize: "17px !important",
          padding: "10px 0 0 100px",
          display: { xs: "none", sm: "block" },
        }}
      >
        No payment required if you are not satisfied in it.
      </Typography>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        // onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        sx={{ "& .MuiDialog-paper": { width: "40%", maxHeight: "90vh" } }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Forgot Password!"}
        </DialogTitle>
        <DialogContent>
          {/* <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{ padding: "0 10px" }}
                // className="login-form"
              >
                <div
                  className="signup_form_group"
                  style={{ marginBottom: "0", padding: "0 10px" }}
                >
                  <span className="field_icon">
                    <FaUserTie />
                    <TextField
                      type="text"
                      name="email"
                      placeholder="Email"
                      sx={{
                        width: "100%",
                        paddingLeft:'30px',
                        backgroundColor: "#fff",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "none !important",
                          },
                        },
                      }}
                    />
                  </span>
                </div>
              </Grid>
            </Grid> */}
        </DialogContent>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ padding: "0 10px" }}>
            <form onSubmit={formik.handleSubmit}>
              <div className="signup_form_group" style={{ padding: "0 10px" }}>
                <span className="field_icon">
                  <IoIosMailOpen />
                  <TextField
                    type="text"
                    name="email"
                    placeholder="Email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    sx={{ width: "100%", backgroundColor: "#fff" }}
                  />
                </span>

                {formik.touched.email && formik.errors.email ? (
                  <div className="login_error">{formik.errors.email}</div>
                ) : null}
              </div>
            </form>
          </Grid>
        </Grid>
        <DialogActions className="forgot_password_modal_btns">
          <button
            type="submit"
            onClick={handleOnClickSubmitForgotPassword}
            style={authStatus === "loading" ? { padding: "7px 40px" } : {}}
          >
            {authStatus === "loading" ? (
              <CircularProgress size={12} sx={{ color: "#fff" }} />
            ) : (
              "Submit"
            )}
          </button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </Box>
  );
};

export default Login;
